import React from 'react';
import { OrderingConstants, OrderingSelectors } from 'polygon-ordering';
import { useAppSelector } from '../app/hooks';
import PaymentWrapper from '../components/PaymentProvider';
import { TyroProvider } from '../hooks/TyroProvider';
import PurchaseGiftCardScreen from './PurchaseGiftCardScreen';

export const PURCHASE_GIFT_CARD_ROUTE = '/purchase-gift-card';

const { getGatewayType } = OrderingSelectors;
const { PAYMENT_GATEWAY_TYPES } = OrderingConstants;

const PurchaseGiftCardScreenWrapper = () => {
  const gatewayType = useAppSelector(getGatewayType);
  let PaymentProviderWrapper: any;

  if (gatewayType === PAYMENT_GATEWAY_TYPES.STRIPE) {
    PaymentProviderWrapper = PaymentWrapper;
  } else if (gatewayType === PAYMENT_GATEWAY_TYPES.TYRO) {
    PaymentProviderWrapper = TyroProvider;
  }

  return PaymentProviderWrapper ? (
    <PaymentProviderWrapper>
      <PurchaseGiftCardScreen />
    </PaymentProviderWrapper>
  ) : (
    <PurchaseGiftCardScreen />
  );
};

export default PurchaseGiftCardScreenWrapper;
